<template>
  <div>
    
    <div class="fixed-top bg-body-tertiary text-center top-navbar" >
        <div class="row" role="tablist">
            <div class="col"  role="presentation">
                <button class="nav-link active" id="mainCurrency-tab" data-bs-toggle="tab" data-bs-target="#mainCurrency" type="button" role="tab" aria-controls="mainCurrency" aria-selected="true">주요지표</button>
            </div>
            <div class="col"  role="presentation">
                <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">환율비교</button>
            </div>
            <!-- <div class="col">
                <button class="nav-link" id="timeMachine-tab" data-bs-toggle="tab" data-bs-target="#timeMachine" type="button" role="tab" aria-controls="timeMachine" aria-selected="false">타임머신</button>
            </div> -->
          </div>
          <div class="progress mainCurrencyProgress">
            <div class="progress-bar progress-bar-animated" :style="progressBarWidth"  role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
    </div>

    <!-- <HeaderComponent /> -->
    <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="mainCurrency" role="tabpanel" aria-labelledby="mainCurrency-tab">
              <table id ="mainCurrencyTable" class="table va-middle">
                <tbody>
                  <tr class='tr-main-currency' v-for="(v, i) in exchRateData" :key="`data${i}`">
                    <td class="current-price-ticker-name">
                        <h5 class="text-ellipsis fw-bold">{{v.TICKER_NAME}}</h5>
                        <h8><i class="fa-regular fa-clock mr5" :class="[v.IS_MARKET_OPEN === 'Y' ? 'text-green':'text-red']"></i>{{v.FMT_NOTICE_DATETIME}}</h8>
                    </td>
                    <td class='text-right' :class="[v.DAY_CHANGE_RATE > 0 ? 'text-red' : 'text-blue']">
                        <h5 :class="[v.DAY_CHANGE_RATE > 0 ? 'text-red' : 'text-blue']">{{numFormat(v.BASE_EXCH_RATE)}}</h5>
                        <h7>{{numFormat(v.DAY_MIN_EXCH_RATE)}}-{{numFormat(v.DAY_MAX_EXCH_RATE)}}</h7>
                    </td>
                    <td class='text-right' :class="[v.DAY_CHANGE_RATE > 0 ? 'text-red' : 'text-blue']">
                        <h7>{{numFormat(v.DAY_CHANGE_AMT)}}</h7><br/>
                        <h7>{{numFormat(v.DAY_CHANGE_RATE)}}%</h7>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- 은행별 환율비교 -->
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <h1>은행별 환율비교</h1>
            </div>
            
            <!-- 타임머신 -->
            <div class="tab-pane fade" id="timeMachine" role="tabpanel" aria-labelledby="timeMachine-tab">
              <h1>타임머신</h1>
            </div>
    </div>
    
    <div class="sticky-bottom-right">
        <button type="button" class="btn btn-primary btn-lg btn-round" @click="getData()"><i class="fa-solid fa-rotate"></i></button>
    </div>
    <GlobalNavigationBar />
  </div>
</template>

<script>
import { fetchGet, fetchPost } from '../api/fetch.js';
import * as cmmJs from '../js/cmmJs.js'
// import HeaderComponent from "../components/HeaderComponent.vue";
import GlobalNavigationBar from "../components/GlobalNavigationBar.vue";
export default {
  components: {
    // HeaderComponent,
    GlobalNavigationBar,
  },
  data() {
    return {
      exchRateData: [],
      timeMachineData: {},
      progressTimer:0,
      progressWidth:0
    };
  },
  mounted() {
    this.getData();
    setInterval(this.renderProgressBar, 1000)
  },
  computed: {
    progressBarWidth () {
      return {
        'width': this.progressWidth+'%' // testColor 는 예시 변수명
      }
    }
  },
  methods: {
    numFormat: cmmJs.numFormat,
    getData: function() {
      fetchGet('/api/getExchRate')
      .then((res) => {
        // 성공했을 경우
        // this.exchRateData = res.data.exchRateData;
        this.exchRateData = res.data.exchRateData.filter((o) => o.BANK_CODE === '00');
      })
      .catch((res) => {
        // 실패했을 경우
        console.error(res);
      });
      
    },
    renderProgressBar: function(){
      const interval = 60;
      this.progressWidth = Math.round(++this.progressTimer / interval * 100);
      if(this.progressWidth > 100){
        this.progressTimer = 0;
        this.progressWidth = 0;
        this.getData();
      }
    }
  },
  
 
};
</script>

<style scoped>
</style>